import { colors } from '@mui/material';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  root: {
    backgroundColor: colors.grey[50]
  }
};
